import CustomDialog from "global/components/CustomDialog/CustomDialog";
import {
  Box,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import campaignStyles from "../Campaigns.styles";
import { campaignTypes } from "../CampaignConstants";
import history from "utils/history";
import { useAppSelector } from "utils/hooks";
import { isTrial } from "redux/authSlice";
import CustomInfoTooltip from "global/components/CustomInfoTooltip/CustomInfoTooltip";

interface CustomProps {
  isDialogOpen: boolean;
  handleDialogClose: Function;
}

const CreateCampaign = (props: CustomProps) => {
  const theme = useTheme();
  const classes = campaignStyles(theme);
  const isTrialAccount = useAppSelector(isTrial);

  const getBody = () => {
    return (
      <Grid container rowSpacing={2} columnSpacing={2} alignItems="center">
        {campaignTypes().map((campaign) => {
          const isDisabled = isTrialAccount && !campaign.permittedForTrial;
          return (
            <CustomInfoTooltip
              infoMessage={
                isDisabled
                  ? `Subscribe to any plan to use ${campaign.title}`
                  : ""
              }
              placement="left"
            >
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  sx={{
                    ...classes.borderedBox,
                    p: 3,
                    cursor: campaign.isUserPermitted
                      ? "pointer"
                      : "not-allowed",
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                  onClick={() =>
                    !isDisabled &&
                    campaign.isUserPermitted &&
                    history.push(campaign.link)
                  }
                >
                  <img src={campaign.icon} alt={campaign.title} />
                  <Typography
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                      mt: 2,
                    }}
                    variant="h6"
                  >
                    {campaign.title}
                  </Typography>
                  {!isDisabled ? (
                    campaign.isUserPermitted ? (
                      <Typography
                        variant="body2"
                        sx={{ mt: 1 }}
                        color={theme.palette.primary.dark}
                      >
                        {campaign.desc}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        sx={{ mt: 1 }}
                        color="#ff4244"
                      >
                        * You don't have necessary permissions to run the{" "}
                        {campaign.title.toLocaleLowerCase()}. Please contact
                        your account administrator.
                      </Typography>
                    )
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ mt: 1 }}
                      color={theme.palette.primary.dark}
                    >
                      {campaign.desc}
                    </Typography>
                  )}
                </Box>
              </Grid>
            </CustomInfoTooltip>
          );
        })}
      </Grid>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isDialogOpen}
      body={getBody()}
      title={
        <Typography variant="h4" color="primary">
          Create Campaign
        </Typography>
      }
      closeButtonVisibility
      closable
      maxWidth="xl"
    />
  );
};

export default CreateCampaign;
